import React from "react";
import { injectIntl } from "react-intl";
import ReactTooltip from "react-tooltip";
import "./HelpButton.css";
import If from "common/components/if";
import PropTypes from "prop-types";

function openHelp(helpUrl) {
  window.open(helpUrl, "CfpsHelpWindow", "resizable,scrollbars,status");
}

/**
 * If provided with a `helpUrl` property, displays a clickable help icon that will open a new window
 * pointing to the provided url. The button has a tooltip built in.
 * Note: This component already conditionally renders depending on the existence of `helpUrl`, don't
 * bother wrapping it in another condition check.
 */
function HelpButton({ helpUrl, intl }) {
  return (
    <If condition={!!helpUrl}>
      <div
        className="help-button"
        data-tip={intl.formatMessage({ id: "alpha.help" })}
        data-for="helpText"
      >
        <i
          id="helpIcon"
          onClick={openHelp.bind(null, helpUrl)}
          className="icon-question-sign"
        />
        <ReactTooltip id="helpText" effect="solid" place="bottom" />
      </div>
    </If>
  );
}

HelpButton.propTypes = {
  // (Optional) The target URL for the help popup.
  // If not provided, this component will render nothing
  helpUrl: PropTypes.string,
  // Injected by injectIntl
  intl: PropTypes.object.isRequired
};

HelpButton.defaultProps = {
  helpUrl: null
};

export default injectIntl(HelpButton);
